module.exports = __webpack_public_path__ + "img/point_logo.a8f8d93e.png";